module.exports = __webpack_public_path__ + "static/pic_videoPoster-6372a302f930d19f467e758a4a72f1a9.jpg";